// Import your images
// Make sure to adjust the import paths according to your project structure
import mechImg from '../img/aaaservices/VR.webp';
import mecadvance from '../img/aaaservices/virtual.webp';
import roboexpert from '../img/aaaservices/expertrobot.jpg';

import simImg from '../img/aaaservices/slashco-bridle1-2.jpg';
import tollbasic from '../img/aaaservices/toolbasic.jpg';
import tollexpert from '../img/aaaservices/tollexpert.jpg';


import itImg from '../img/aaaservices/Java-Full-Stack-1-600x367.jpg';
import advncejava from '../img/aaaservices/advncejava.jpg'; 
import javaexpert from '../img/aaaservices/javaexpert.png';
import digitaladvance from '../img/aaaservices/digitaladvance.jpg';
import digitalexpert from '../img/aaaservices/digitalexpert.avif';

import itImg1 from '../img/aaaservices/PY.jpg';
import advancepython from '../img/aaaservices/adancepython.jpg';
import pythonexpert from '../img/aaaservices/pynew.png';
import reactdev from '../img/aaaservices/reactada.jpg';
import fluuterdev from '../img/aaaservices/fluuterdata.jpg';
import springboot from '../img/aaaservices/javaspring.jpg';
import itImg2 from '../img/aaaservices/app-development-banner_33099-1720.avif';
import dfsImg from '../img/aaaservices/F.png';

export const cardData = {
  Mechanical: [
    {
      id: 1,
      title: "Virtual Robotics - Basic",
      subtitle: "Robotics Fundamentals & Automation",
      date: "2025-06-01",
      time: "10:00 AM - 4:00 PM",
      cost: "₹14,999",
      minPrice: 14999,
      maxPrice: 14999,
      duration: "2 Months",
      location: "hyderabad",
      language: "english",
      image: mechImg,
      link: "/Virtualpage",
      level: "basic"
    },
    {
      id: 2,
      title: "Virtual Robotics - Advanced",
      subtitle: "Industrial Robotics & Programming",
      date: "2025-06-05",
      time: "11:00 AM - 5:00 PM",
      cost: "₹29,999",
      minPrice: 29999,
      maxPrice: 29999,
      duration: "3 Months",
      location: "hyderabad",
      language: "english",
      image: mecadvance,
      link: "/Virtualpage",
      level: "advanced"
    },
    {
      id: 3,
      title: "Virtual Robotics - Expert",
      subtitle: "AI Robotics & Smart Factory Automation",
      date: "2025-06-10",
      time: "9:00 AM - 3:00 PM",
      cost: "₹59,999",
      minPrice: 59999,
      maxPrice: 59999,
      duration: "4 Months",
      location: "hyderabad",
      language: "english",
      image: roboexpert,
      link: "/Virtualpage",
      level: "expert"
    },
    {
      id: 4,
      title: "Tool & Fixture Design - Basic",
      subtitle: "Fundamentals of Tool Design",
      date: "2025-06-15",
      time: "10:00 AM - 4:00 PM",
      cost: "₹14,999",
      minPrice: 14999,
      maxPrice: 14999,
      duration: "2 Months",
      location: "hyderabad",
      language: "english",
      image: simImg,
      link: "/fixture",
      level: "basic"
    },
    {
      id: 5,
      title: "Tool & Fixture Design - Advanced",
      subtitle: "Industrial Tool & Fixture Development",
      date: "2025-06-20",
      time: "11:00 AM - 5:00 PM",
      cost: "₹29,999",
      minPrice: 29999,
      maxPrice: 29999,
      duration: "3 Months",
      location: "hyderabad",
      language: "english",
      image: tollbasic,
      link: "/fixture",
      level: "advanced"
    },
    {
      id: 6,
      title: "Tool & Fixture Design - Expert",
      subtitle: "Master Tooling & Manufacturing Solutions",
      date: "2025-06-25",
      time: "9:00 AM - 3:00 PM",
      cost: "₹59,999",
      minPrice: 59999,
      maxPrice: 59999,
      duration: "4 Months",
      location: "hyderabad",
      language: "english",
      image: tollexpert,
      link: "/fixture",
      level: "expert"
    },
    {
      id: 7,
      title: "Digital Factory - Basic",
      subtitle: "Smart Manufacturing Fundamentals",
      date: "2025-07-01",
      time: "10:00 AM - 4:00 PM",
      cost: "₹14,999",
      minPrice: 14999,
      maxPrice: 14999,
      duration: "2 Months",
      location: "hyderabad",
      language: "english",
      image: dfsImg,
      link: "/DigitalC",
      level: "basic"
    },
    {
      id: 8,
      title: "Digital Factory - Advanced",
      subtitle: "Industry 4.0 & Factory Simulation",
      date: "2025-07-05",
      time: "11:00 AM - 5:00 PM",
      cost: "₹29,999",
      minPrice: 29999,
      maxPrice: 29999,
      duration: "3 Months",
      location: "hyderabad",
      language: "english",
      image: digitaladvance,
      link: "/DigitalC",
      level: "advanced"
    },
    {
      id: 9,
      title: "Digital Factory - Expert",
      subtitle: "AI Powered Smart Factory & Automation",
      date: "2025-07-10",
      time: "9:00 AM - 3:00 PM",
      cost: "₹59,999",
      minPrice: 59999,
      maxPrice: 59999,
      duration: "4 Months",
      location: "hyderabad",
      language: "english",
      image: digitalexpert,
      link: "/DigitalC",
      level: "expert"
    }
  ],
  IT: [
    // Java Track
    {
      id: 10,
      title: "Java Programming",
      subtitle: "Core Java Basics",
      date: "2025-06-17",
      time: "1:00 PM - 6:00 PM",
      cost: "₹14,999",
      minPrice: 14999,
      maxPrice: 14999,
      duration: "2 Months",
      location: "hyderabad",
      language: "english",
      image: itImg,
      link: "/it-services",
      level: "basic"
    },
    {
      id: 11,
      title: "Advanced Java Programming",
      subtitle: "Collections, JDBC & OOPs",
      date: "2025-06-19",
      time: "10:00 AM - 2:00 PM",
      cost: "₹29,999",
      minPrice: 29999,
      maxPrice: 29999,
      duration: "3 Months",
      location: "hyderabad",
      language: "english",
      image: advncejava,
      link: "/it-services",
      level: "advanced"
    },
    {
      id: 12,
      title: "Java Full Stack",
      subtitle: "Complete Stack Developer",
      date: "2025-06-21",
      time: "9:00 AM - 5:00 PM",
      cost: "₹59,999",
      minPrice: 59999,
      maxPrice: 59999,
      duration: "4 Months",
      location: "hyderabad",
      language: "english",
      image: javaexpert,
      link: "/it-services",
      level: "expert"
    },
    // Python Track
    {
      id: 13,
      title: "Python Programming",
      subtitle: "Python Fundamentals",
      date: "2025-06-22",
      time: "10:00 AM - 2:00 PM",
      cost: "₹14,999",
      minPrice: 14999,
      maxPrice: 14999,
      duration: "2 Months",
      location: "hyderabad",
      language: "english",
      image: itImg1,
      link: "/Puthonpage",
      level: "basic"
    },
    {
      id: 14,
      title: "Advanced Python Programming",
      subtitle: "Django, APIs & Automation",
      date: "2025-06-24",
      time: "11:00 AM - 4:00 PM",
      cost: "₹29,999",
      minPrice: 29999,
      maxPrice: 29999,
      duration: "3 Months",
      location: "hyderabad",
      language: "english",
      image: advancepython,
      link: "/Puthonpage",
      level: "advanced"
    },
    {
      id: 15,
      title: "Python Full Stack",
      subtitle: "Complete Stack Developer",
      date: "2025-06-26",
      time: "9:00 AM - 5:00 PM",
      cost: "₹59,999",
      minPrice: 59999,
      maxPrice: 59999,
      duration: "4 Months",
      location: "hyderabad",
      language: "english",
      image: pythonexpert,
      link: "/Puthonpage",
      level: "expert"
    },
    // React Only
    {
      id: 16,
      title: "React Development",
      subtitle: "Frontend Framework",
      date: "2025-06-28",
      time: "10:00 AM - 2:00 PM",
      cost: "₹14,999",
      minPrice: 14999,
      maxPrice: 14999,
      duration: "2 Months",
      location: "hyderabad",
      language: "english",
      image: reactdev,
      link: "/Reactpage",
      level: "basic"
    },
    // Flutter Only
    {
      id: 17,
      title: "Flutter Development",
      subtitle: "Cross-Platform Apps",
      date: "2025-06-29",
      time: "10:00 AM - 2:00 PM",
      cost: "₹14,999",
      minPrice: 14999,
      maxPrice: 14999,
      duration: "2 Months",
      location: "hyderabad",
      language: "english",
      image: fluuterdev,
      link: "/Flutterpage",
      level: "basic"
    },
    // Spring Boot & MySQL
    {
      id: 18,
      title: "Spring Boot & MySQL",
      subtitle: "Backend Development",
      date: "2025-06-30",
      time: "11:00 AM - 4:00 PM",
      cost: "₹29,999",
      minPrice: 29999,
      maxPrice: 29999,
      duration: "3 Months",
      location: "hyderabad",
      language: "english",
      image: springboot,
      link: "/Springbootpage",
      level: "advanced"
    },
    // HTML CSS JavaScript
    {
      id: 19,
      title: "HTML, CSS & JavaScript",
      subtitle: "Complete Web Fundamentals",
      date: "2025-07-01",
      time: "10:00 AM - 3:00 PM",
      cost: "₹14,999",
      minPrice: 14999,
      maxPrice: 14999,
      duration: "2 Months",
      location: "hyderabad",
      language: "english",
      image: itImg2,
      link: "/Htmlpage",
      level: "basic"
    }
  ]
};

// Helper function to get all courses
export const getAllCourses = () => {
  return Object.values(cardData).flat();
};

// Helper function to get courses by category
export const getCoursesByCategory = (category) => {
  return cardData[category] || [];
};

// Helper function to get course by ID
export const getCourseById = (id) => {
  const allCourses = getAllCourses();
  return allCourses.find(course => course.id === id);
};

// Helper function to search courses
export const searchCourses = (searchTerm) => {
  const allCourses = getAllCourses();
  if (!searchTerm || searchTerm.trim() === "") {
    return allCourses;
  }
  
  const searchLower = searchTerm.toLowerCase().trim();
  return allCourses.filter((course) => {
    return (
      course.title.toLowerCase().includes(searchLower) ||
      course.subtitle.toLowerCase().includes(searchLower) ||
      course.level.toLowerCase().includes(searchLower) ||
      course.duration.toLowerCase().includes(searchLower) ||
      course.location.toLowerCase().includes(searchLower) ||
      course.cost.toLowerCase().includes(searchLower)
    );
  });
};

// Helper function to filter courses by level
export const filterByLevel = (level) => {
  const allCourses = getAllCourses();
  return allCourses.filter(course => 
    course.level.toLowerCase() === level.toLowerCase()
  );
};

// Helper function to filter courses by location
export const filterByLocation = (location) => {
  const allCourses = getAllCourses();
  return allCourses.filter(course => 
    course.location.toLowerCase() === location.toLowerCase()
  );
};

// Helper function to get unique locations
export const getUniqueLocations = () => {
  const allCourses = getAllCourses();
  const locations = allCourses.map(course => course.location);
  return [...new Set(locations)];
};

// Helper function to get unique levels
export const getUniqueLevels = () => {
  const allCourses = getAllCourses();
  const levels = allCourses.map(course => course.level);
  return [...new Set(levels)];
};